/* global document, HTMLElement */

const FIELD_INPUT_ERROR_CLASS = 'field-input--error';

/** Clears and applies error styling to filter controls under `#report-filters-panel` (not org code). */
export function setReportFilterFieldHighlights(elementIds: readonly string[]): void {
    clearReportFilterFieldHighlights();
    for (const id of elementIds) {
        const control = resolveReportFilterFieldControl(id);
        if (!control) {
            continue;
        }
        control.classList.add(FIELD_INPUT_ERROR_CLASS);
        control.setAttribute('aria-invalid', 'true');
    }
}

/** Removes error styling from all filter controls in the report filters panel. */
export function clearReportFilterFieldHighlights(): void {
    const panel = document.getElementById('report-filters-panel');
    if (!panel) {
        return;
    }
    for (const el of panel.querySelectorAll(
        `.field-input.${FIELD_INPUT_ERROR_CLASS}, .report-radio-group.${FIELD_INPUT_ERROR_CLASS}`
    )) {
        el.classList.remove(FIELD_INPUT_ERROR_CLASS);
        el.removeAttribute('aria-invalid');
    }
}

/**
 * Resolves a {@link ReportFilterFieldSpec.elementId} to the focusable control that carries
 * `field-input` (native input/select or multiselect trigger).
 */
export function resolveReportFilterFieldControl(elementId: string): HTMLElement | null {
    const byId = document.getElementById(elementId);
    if (byId?.classList.contains('field-input')) {
        return byId;
    }
    const trigger = document.getElementById(`${elementId}-trigger`);
    if (trigger?.classList.contains('field-input')) {
        return trigger;
    }
    if (byId?.classList.contains('report-radio-group')) {
        return byId;
    }
    return null;
}
